'use strict';

import template from './micuenta.html';
import controller from './micuenta.controller';
import './micuenta.css';

const DashboardComponent = {
    template,
    controller
};

export default DashboardComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin/micuenta/micuenta.component.js